'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M1.91 10.182a1 1 0 0 1 1-1h18.18a1 1 0 1 1 0 2H2.91a1 1 0 0 1-1-1" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M1 7.728a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4V19a4 4 0 0 1-4 4h-1.546a1 1 0 0 1 0-2H19a2 2 0 0 0 2-2V7.728a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2V19a2 2 0 0 0 2 2h7.454a1 1 0 1 1 0 2H5a4 4 0 0 1-4-4z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M7.455 1a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1M16.546 1a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1M17.455 23h-5v-2h5z" clipRule="evenodd" /></svg>;
const IconCalendar = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconCalendar;